export default __webpack_public_path__ + "static/media/45001_2018_rev_02_2026.3c7ffeb4.pdf";